import * as localForage from 'localforage';
import * as memoryDriver from 'localforage-driver-memory';

import {selectPersistStateInit} from '@datorama/akita';
import { finalize, switchMap, take, timeout } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';
import { SwUpdate } from '@angular/service-worker';
import { of } from 'rxjs';

export function persistStateInitFactory() {
  return () => {
    return new Promise<void>(async resolve => {
      await localForage.defineDriver(memoryDriver);
      localForage.config({
        name: 'patientLynk',
        driver: [localForage.INDEXEDDB, localForage.LOCALSTORAGE, memoryDriver._driver]
      });

      await localForage.ready();
      selectPersistStateInit().subscribe(() => resolve());
    });
  };
}

export function preloadTranslations(transloco: TranslocoService) {
  return () => {
    return new Promise<void>(resolve => {
      const lang = localStorage.getItem('lang') || navigator?.language?.slice(0, 2) || 'en';

      resolve()

      // transloco.load(lang).pipe(
      //   timeout(10000),
      //   take(1),
      //   finalize(() => resolve()),
      // ).subscribe();
    });
  };
}

export function forceUpdate(swUpdate: SwUpdate) {
  return () => {
    return new Promise<void>(resolve => {
      of(true).pipe(
        switchMap(() => swUpdate.checkForUpdate()),
        switchMap(() => swUpdate.versionUpdates.pipe(
          timeout(500),
        )),
        switchMap(() => swUpdate.activateUpdate()),
        switchMap(() => swUpdate.activateUpdate()),
      ).subscribe(
        () => window.location.reload(),
        () => resolve()
      );
    });
  };
}
